import { SearchBoxProvided } from 'react-instantsearch-core';
import { useState } from 'react';
import DebouncedInput from '~/apps/smartsend/components/DebouncedInput';

interface ISearchBoxProps extends SearchBoxProvided {
  refine(s: string): unknown;
  currentRefinement: string | (() => string);
}

const SearchBox: React.FC<ISearchBoxProps> = (props) => {
  const [search, setSearch] = useState<string>(props.currentRefinement);
  return (
    <DebouncedInput
      id="txtSearch"
      label="Search"
      value={search}
      autoComplete="none"
      debounceTime={350}
      onChange={(s) => {
        setSearch(s);
        props.refine(s);
      }}
      fullWidth
    />
  );
};
export default SearchBox;
